import { render, staticRenderFns } from "./IconSvgHigherLogic.vue?vue&type=template&id=28d57075&scoped=true&"
import script from "./IconSvgHigherLogic.vue?vue&type=script&lang=js&"
export * from "./IconSvgHigherLogic.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28d57075",
  null
  
)

export default component.exports